import {getLocationFormattedAddress, getLocationName} from '@wix/wix-events-commons-statics'
import React from 'react'
import {useWidgetState} from '../../../../hooks/state-provider'
import {getLocationMargin, isLocationVisible} from '../../../../selectors/single-settings'
import {Presentation} from '../presentation'
import {LocationProps} from './interfaces'

export const Location = ({event, dataHook, className}: LocationProps) => {
  const locationVisible = useWidgetState(isLocationVisible)
  const marginBottom = useWidgetState(getLocationMargin)

  return locationVisible ? (
    <div style={{marginBottom}} className={className}>
      <Presentation
        dataHook={dataHook}
        text={getLocationName(event)}
        text2={getLocationFormattedAddress(event)}
        settingsKey="location"
      />
    </div>
  ) : null
}
